import type { Theme } from '../../themes/themes';

export const createDividerTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: theme.palette.divider,
          variants: [
            {
              props: {
                variant: 'listicle',
              },
              style: {
                borderColor: theme.palette.text.overline,

                ':before, :after': {
                  borderColor: theme.palette.text.overline,
                  borderBlockStartWidth: '2px',
                },

                '.MuiDivider-wrapper': {
                  ...theme.typography.c1,
                  border: '2px solid',
                  borderColor: theme.palette.text.overline,
                  borderRadius: '100%',
                  minWidth: theme.spacing(9),
                  minHeight: theme.spacing(9),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
                [theme.breakpoints.up('lg')]: {
                  '& .MuiDivider-wrapper': {
                    minWidth: theme.spacing(12),
                    minHeight: theme.spacing(12),
                  },
                },
              },
            },
            {
              props: {
                variant: 'fullWidth',
              },
              style: {
                gridColumn: 'span 12',

                ':before, :after': {
                  borderColor: theme.palette.primary['main'],
                  borderBlockStartWidth: '1px',
                },

                '.MuiDivider-wrapper': {
                  border: '1px solid',
                  borderColor: theme.palette.primary['main'],
                  borderRadius: '100%',
                  minWidth: theme.spacing(9),
                  minHeight: theme.spacing(9),
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                },
                [theme.breakpoints.up('lg')]: {
                  '& .MuiDivider-wrapper': {
                    minWidth: theme.spacing(12),
                    minHeight: theme.spacing(12),
                  },
                },
              },
            },
            {
              props: {
                variant: 'dark',
              },
              style: {
                borderColor: theme.palette.secondary.darker,
              },
            },
          ],
        },
      },
    },
  },
});
